import { useState } from 'react';
import './Dashboard.css';
import QuickSummary from './QuickSummary';
import UpcomingExams from './UpcomingExams';
import { FiMenu, FiSearch, FiFileText, FiShield, FiLogOut, FiSettings, FiX, FiUserCheck } from 'react-icons/fi'; // hamburger icon
import profilePic from '../../Assets/profile-placeholder.jpeg';
import QuizOfTheDay from './QuizOfTheDay';
import PerformanceTracker from './PerformanceTracker';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import '../Admin-Dashboard-Component/AdminDashboard.css'
import { Typography, Box } from '@mui/material'; // <-- Add this at top
import { Badge, IconButton } from '@mui/material';
import { FiBell } from 'react-icons/fi'; // Notification icon
import { Navigate } from 'react-router-dom';
import React, { useRef } from 'react'; // <-- Add useRef
import './PerformanceTracker.css';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import './SearchBar.css'; // we'll add CSS here
import 'primeicons/primeicons.css';
import { DASHBOARD_TEXT, } from '../../TextConstants';
import StudentVouchersModal from './StudentVoucherComponent/StudentVouchersModal';

function Dashboard() {

    const performanceRef = useRef(); // <-- Ref for scrolling
    const [pulse, setPulse] = useState(false);
    const [notificationCount, setNotificationCount] = useState(3); // replace with dynamic fetch later
    const [sidebarOpen, setSidebarOpen] = useState(false);
    // const studentData = JSON.parse(localStorage.getItem('studentData'));


    const studentData = JSON.parse(localStorage.getItem('studentData'));
    const studentToken = localStorage.getItem('student_token'); //  your token
    const studentId = studentData?.id; // dynamic student ID
    console.log("Student ID for vouchers:", studentId);
    const studentName = studentData?.name || "Student";
    console.log("Student Data:", studentData);
    console.log("Student Token:", studentToken);


    const [showVouchersModal, setShowVouchersModal] = useState(true); // initially true to show modal on load

    const [notifications, setNotifications] = useState([
        { id: 1, message: 'Exam tomorrow!', read: false },
        { id: 2, message: 'Assignment due', read: false },
        { id: 3, message: 'Result published', read: true },
    ]);

    const unreadCount = notifications.filter(n => !n.read).length;
    const navigate = useNavigate();

    const triggerScrollToPerformance = () => {
        if (performanceRef.current) {
            performanceRef.current.scrollIntoView({ behavior: 'smooth' });
            setPulse(true);
            setTimeout(() => setPulse(false), 1000); // Remove class after 1s
        }
    };

    const [focused, setFocused] = useState(false);


    return (
        <div className="dashboard-container">
            <header className="dashboard-header">
                <div
                    className="menu-icon"
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    title={sidebarOpen ? 'Close Menu' : 'Open Menu'}
                >
                    {sidebarOpen ? (
                        <FiX size={28} className="menu-toggle-icon close-icon" />
                    ) : (
                        <FiMenu size={28} className="menu-toggle-icon open-icon" />
                    )}
                </div>

                {/* Center: Animated "Student Dashboard" heading */}
                <Box
                    sx={{
                        position: 'absolute',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <Typography
                        variant="h5"
                        sx={{
                            fontSize: {
                                xs: '0.75rem',   // smaller than 0.8rem
                                sm: '1rem',      // smaller than 1.1rem
                                md: '1.25rem'    // smaller than 1.5rem
                            }


                            ,
                            fontWeight: 'bold',
                            // background: 'linear-gradient(90deg, #00c9ff, #92fe9d)',
                            background: 'var(--primary-gradient)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            textTransform: 'uppercase',
                            letterSpacing: '1.0px',
                            animation: 'slideIn 1s ease-in-out',
                            position: 'relative',
                            // px: 2,
                            transition: 'transform 0.3s ease, text-shadow 0.3s ease',
                            '&::after': {
                                content: '""',
                                display: 'block',
                                width: '100%',
                                height: '4px',
                                margin: '8px auto 0 auto',
                                // background: 'linear-gradient(90deg, #00c9ff, #92fe9d)',
                                background: 'var(--primary-gradient)',
                                borderRadius: '2px',
                                animation: 'underlineGrow 1s ease-in-out',
                            },
                            '&:hover': {
                                transform: 'scale(1.05)',
                                textShadow: '0 0 10px rgba(0, 201, 255, 0.7)',
                            }
                        }}
                    >
                        {DASHBOARD_TEXT.title}
                    </Typography>
                </Box>


                <div className="profile-section">
                    <div className="header-icons">
                        <div
                            className="notification-wrapper"
                            onClick={() => navigate("/student-notifications")}
                            title="Notifications"
                        >
                            <FiBell size={30} className="bell-icon" />
                            {notificationCount > 0 && (
                                <span className="notification-badge">{notificationCount}</span>
                            )}
                        </div>
                    </div>
                    <img src={profilePic} alt="Profile" className="profile-avatar" />
                    <div className="greeting-text">
                        <span className="greet">Hello,</span>
                        <span className="student-name">{studentName}</span>
                    </div>
                </div>
            </header>

            {/* code for search bar*/}
            {/* <div className="search-bar">
                <input
                    type="text"
                    placeholder="Search by subject or exam..."
                    className="search-input"
                /> */}

            {/* search button code */}
            {/* <button className="search-button">
                    <FiSearch size={16} />
                    <span>Search</span>
                </button> */}
            {/* </div> */}


            {/* Main content of dashboard */}
            <main className="dashboard-main">
                <h2 className='welcome-text'>{DASHBOARD_TEXT.heading}</h2>
            </main>

            {/* animated search bar using react prime */}
            <div className={`p-inputgroup search-bar-enhanced ${focused ? 'focused' : ''}`}>
                <InputText
                    placeholder="Search by subject or exam..."
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                />
                <Button icon="pi pi-search" label="Search" className="p-button-info search-btn-animated" />
            </div>



            {/* code for quick summary cards */}
            <QuickSummary onProgressClick={triggerScrollToPerformance} />

            {/* file of upcoming exams */}
            <div className='dashboard-grid' id='upcoming-exams'>
                <div className='grid-item' >
                    <div
                        ref={performanceRef}
                        className={`section-wrapper ${pulse ? 'pulse-animate' : ''}`}
                    >
                        <UpcomingExams studentId={studentId} />
                        <PerformanceTracker />
                    </div>
                </div>

                <div className='grid-item'>
                    <div className="section-wrapper" id='quiz-section'>
                        <QuizOfTheDay />
                    </div>
                </div>

                {/* <QuizOfTheDay/> */}
            </div>


            {/* file for running performance tracker */}
            {/* <div className='dashboard-grid'>
                <div className='grid-item'>
                    <div className="section-wrapper">
                        <PerformanceTracker />
                    </div>
                </div>
            </div> */}

            {/* You can conditionally render sidebar here */}
            {sidebarOpen && (
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            )}

            {/* Student vouchers modal */}
            <StudentVouchersModal
                studentId={studentId}
                visible={showVouchersModal}
                onClose={() => setShowVouchersModal(false)}
            />

        </div>

    );
}

export default Dashboard;
